import { render } from "./attachment-v2.vue?vue&type=template&id=f4dc8e74&ts=true"
import script from "./attachment-v2.vue?vue&type=script&lang=ts"
export * from "./attachment-v2.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__